<template>
  <template v-if="moduleEnCours">
    <div class="element__detail">
      <div class="flex flex-gap-1">
        <BasicText
          size="h4"
          weight="bold"
        >
          #{{ activeModuleIndex! + 1 }} Organisme de formation {{ moduleEnCours.typeModule }}
        </BasicText>
        <BasicIcon
          @click="définirModuleEnCours(null)"
          name="close"
          class="element__detail--hide"
        />
      </div>
      <BasicButton
        v-if="!readonly && !moduleEnCours.isPreSaisieOf"
        variant="outlined"
        label="Supprimer"
        icon-name="minus-square"
        @click="supprimerModule(activeModuleIndex!)"
        class="element__detail--delete"
      />
    </div>
    <InformationsModule :id="idScrollDownToSaisie" />
    <ModaliteModule />
    <AdresseModule />
    <Formation />
    <CoutFormation />
  </template>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import InformationsModule from '../informations/InformationsModule.vue'
  import AdresseModule from '../adresse/adresseModule.vue'
  import Formation from '../formation/FormationModule.vue'
  import CoutFormation from '../frais/CoutFormation.vue'
  import ModaliteModule from '../modalite/ModaliteModule.vue'

  const store = useDemandeAFStore()
  const { readonly } = storeToRefs(store)

  const { activeModuleIndex, supprimerModule, définirModuleEnCours, moduleEnCours, idScrollDownToSaisie } =
    inject<ModuleAction>(ModuleActionKey)!
</script>
